{% block prems_discount_customer_selector_content %}
    <div class="sw-condition-line-item-in-category sw-condition__condition-value">
        <sw-entity-multi-select
            :label="$tc('prems-discount-category.detail.card.customerRestriction.field.customerLabel')"
            :placeholder="$tc('prems-discount-category.detail.card.customerRestriction.field.customerPlaceholder')"
            size="medium"
            entity="customer"
            :criteria="customerCriteria"
            :entityCollection="customers"
            show-clearable-button
            @update:entity-collection="setCustomerIds"
        >
            <template #result-label-property="{ item }">
                <div style="overflow: hidden;">
                    <span style="float: left;">
                        {{ item.firstName + ' ' + item.lastName }}
                    </span>
                    <span
                        style="text-align: right; float: right; color: rgba(0,0,0,0.5);"
                    >
                        {{ item.customerNumber }}
                    </span>
                    <br/>
                    {{ item.email }}
                </div>
            </template>

            <template #selection-label-property="{ item }">
                {{ item.firstName + ' ' + item.lastName }}
            </template>
        </sw-entity-multi-select>
    </div>
{% endblock %}